(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/analytics-utils/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/casino-react/analytics-utils/assets/javascripts/utils.js');

'use strict';

const getAnalyticsPosition = _ref => {
  let isSearched = _ref.isSearched;
  if (isSearched) {
    return 'search-game-card';
  }
  return 'game-card';
};
const exported = {
  getAnalyticsPosition
};
setGlobal('svs.components.casino_react.analytics_utils.utils', exported);

 })(window);